var map = {
	"./activon-logo-1.jpg": 2002,
	"./activon-logo.jpg": 5013,
	"./activon-tube-pouring-advancis.jpg": 662,
	"./advasil-conform-advancis.jpg": 5844,
	"./belasia-carousel-logo.png": 8481,
	"./belasia-logo.png": 6094,
	"./blood-grouping-abo.png": 2583,
	"./blue-diver-machine.jpg": 9470,
	"./colorful-test-kits.jpg": 7597,
	"./facebook-logo.png": 5548,
	"./handshake.png": 5988,
	"./instagram-logo.png": 8984,
	"./linkedin-logo.png": 472,
	"./lorne-logo.jpg": 2117,
	"./machine-test-tube.png": 7176,
	"./manuka-badge.jpg": 8661,
	"./polymachine.png": 1675,
	"./rpr-carbon-kit.jpeg": 6135,
	"./snibe-logo.png": 9872,
	"./test-kits.jpg": 4910,
	"./test-vial.jpg": 2988,
	"./working-together.jpg": 7159,
	"./wound-dressing-advancis.jpg": 122,
	"./zentech-baby2.jpg": 8745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1041;